import type { PrivyClientConfig } from '@privy-io/react-auth';

export const privyConfig: { appId: string; config: PrivyClientConfig } = {
  appId: process.env.NEXT_PUBLIC_PRIVY_APP_ID!,
  config: {
    loginMethods: ['google', 'wallet'],
    appearance: {
      theme: 'light',
      logo: 'https://algoglide.com/images/AppImages/windows11/LargeTile.scale-100.png',
    },
    embeddedWallets: {
      ethereum: { createOnLogin: 'off' },
      solana: { createOnLogin: 'off' },
    },
  },
}
